module.exports = __webpack_public_path__ + "img/ten-million-trees.a2153669.png";